import { Card, Checkbox, Button, Badge, SearchInput } from '@aimsos/ui';
import { Settings } from 'lucide-react';

const InitialToolsView = ({
  t,
  searchQuery,
  onSearchChange,
  tools,
  selectedTools,
  onToolSelection,
  onToolConfiguration,
}) => {
  const safeTools = Array.isArray(tools) ? tools : [];

  return (
    <>
      <div className="mb-6 flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <h2 className="text-lg font-semibold text-content">{t('edit.tools.slideoutTitle')}</h2>
          <p className="text-sm text-content-muted">{t('edit.tools.slideoutSubtitle')}</p>
        </div>
        <SearchInput
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('edit.tools.searchPlaceholder')}
          onClear={() => onSearchChange('')}
        />
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto pr-2">
        <div className="flex flex-col gap-3 pb-4">
          {safeTools.map((tool) => {
            const safeId = tool?.action_uuid ?? tool?.id ?? tool?.name;
            const safeTitle = tool?.name ?? tool?.label ?? tool?.title ?? '';
            const safeDesc = tool?.description ?? '';

            return (
              <Card
                key={safeId}
                className="cursor-pointer transition-colors hover:bg-surface-hover-subtle"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  if (e.target.closest('[data-tool-card-exclude-toggle]')) return;
                  onToolSelection(safeId);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToolSelection(safeId);
                  }
                }}
              >
                <Card.Body className="flex flex-row items-start gap-3 py-4">
                  <div
                    className="pt-0.5"
                    data-tool-card-exclude-toggle
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      size="small"
                      checked={selectedTools.includes(safeId)}
                      onChange={() => onToolSelection(safeId)}
                      aria-label={t('edit.tools.selectTool', { title: safeTitle })}
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-base font-semibold text-content">{safeTitle}</h3>
                    <p className="mt-1 text-sm text-content-muted">{safeDesc}</p>
                    {tool.tag ? (
                      <div className="mt-2">
                        <Badge variant={tool.tagColor === 'alert' ? 'alert' : 'informative'} size="small">
                          {tool.tag}
                        </Badge>
                      </div>
                    ) : null}
                  </div>
                  <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    leftIcon={Settings}
                    className="shrink-0"
                    data-tool-card-exclude-toggle
                    disabled={!selectedTools.includes(safeId)}
                    onClick={(e) => {
                      e.stopPropagation();
                      onToolConfiguration(tool);
                    }}
                    aria-label={t('edit.tools.configureFromLibrary')}
                  />
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default InitialToolsView;
